import QuestionAnswer from './QuestionAnswer';
export default QuestionAnswer;
